/*
 *
 * AudienceDetail reducer
 *
 */
import produce from "immer";

import {
  FLUSH_STATE_AUDIENSE,
  INITIAL_ID,
  // load item detail
  LOAD_AUDIENSE,
  LOAD_AUDIENSE_SUCCESS,
  LOAD_AUDIENSE_ERROR,
  // update item
  UPDATE_AUDIENSE,
  UPDATE_AUDIENSE_SUCCESS,
  UPDATE_AUDIENSE_ERROR,
  // delete item
  HARD_DELETE_AUDIENSE,
  HARD_DELETE_AUDIENSE_SUCCESS,
  HARD_DELETE_AUDIENSE_ERROR,
} from "./constants";

export const initialState = {
  initialID: null,
  firstRender: true,
  // load detail item
  itemDetail: false,
  detailID: null,
  loadDetail: true,
  errorDetail: false,
  // update
  changeAction: "new",
  isNew: false,
  isNewSuccessful: false,
  updateSuccessful: false,
  loadingUpdate: false,
  errorUpdate: false,
  // hard Delete
  hardDeleteId: null,
  hardDeleteDetail: false,
  hardDeleteSuccessful: false,
  hardDeleteLoading: false,
  hardDeleteError: false,
};

import { getUniqueArrayObj } from "utils/helpers/helper.general";

/* eslint-disable default-case, no-param-reassign */
const audienceDetailReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE_AUDIENSE:
        return initialState;

      case INITIAL_ID:
        draft.initialID = action.initialID;
        if (action.initialID == "new") {
          draft.itemDetail = false;
          draft.loadDetail = false;
          draft.errorDetail = false;
        }
        break;

      // LOAD DETAIL
      case LOAD_AUDIENSE:
        draft.loadDetail = true;
        draft.errorDetail = false;
        draft.isNew = false;
        draft.isNewSuccessful = false;
        draft.loadingUpdate = false;
        draft.updateSuccessful = false;
        draft.hardDeleteLoading = false;
        draft.hardDeleteSuccessful = false;
        draft.detailID = action.detailID;
        break;

      case LOAD_AUDIENSE_SUCCESS:
        draft.itemDetail = action.itemDetail;
        draft.loadDetail = false;
        break;

      case LOAD_AUDIENSE_ERROR:
        draft.errorDetail = action.errorDetail;
        draft.loadDetail = false;
        break;

      // CHANGE/UPDATE for Single Element
      case UPDATE_AUDIENSE:
        draft.itemDetail = action.itemDetail;
        draft.changeAction = action.changeAction;
        draft.loadingUpdate = true;
        draft.errorUpdate = false;
        draft.isNewSuccessful = false;
        draft.updateSuccessful = false;
        draft.hardDeleteLoading = false;
        draft.hardDeleteSuccessful = false;
        draft.isNew = false;
        if (!!!action.itemDetail?._id) {
          draft.isNew = true;
        }
        break;
      case UPDATE_AUDIENSE_SUCCESS:
        draft.loadingUpdate = false;
        const { itemDetail } = action;

        if (itemDetail?._id) {
          if (state.isNew || !!!state.itemDetail?._id) {
            draft.isNewSuccessful = true;
            draft.updateSuccessful = false;
          } else {
            draft.isNewSuccessful = false;
            draft.updateSuccessful = true;
          }

          draft.itemDetail = action.itemDetail;
          draft.errorUpdate = false;
        } else {
          draft.itemDetail = false;
          if (itemDetail?.code == 500) {
            console.error("error 500:", { itemDetail });
            draft.errorUpdate = itemDetail?.message;
          } else if (itemDetail?.code == 200) {
            draft.errorUpdate = itemDetail?.message;
          }
        }

        break;
      case UPDATE_AUDIENSE_ERROR:
        draft.errorUpdate = action.errorUpdate;
        draft.loadingUpdate = false;
        draft.isNew = false;
        draft.isNewSuccessful = false;
        draft.updateSuccessful = false;
        break;

      // HARD DELETE for Single Element
      case HARD_DELETE_AUDIENSE:
        draft.hardDeleteId = action.hardDeleteId;
        draft.hardDeleteLoading = true;
        draft.hardDeleteError = false;
        draft.isNew = false;
        draft.isNewSuccessful = false;
        draft.loadingUpdate = false;
        draft.updateSuccessful = false;
        draft.hardDeleteSuccessful = false;

        break;
      case HARD_DELETE_AUDIENSE_SUCCESS:
        draft.hardDeleteLoading = false;
        draft.hardDeleteError = false;
        draft.hardDeleteDetail = action.hardDeleteDetail;
        draft.hardDeleteId = action.hardDeleteId;

        if (action.hardDeleteDetail && action.hardDeleteId) {
          draft.hardDeleteSuccessful = true;
        }

        break;
      case HARD_DELETE_AUDIENSE_ERROR:
        draft.hardDeleteError = action.hardDeleteError;
        draft.hardDeleteLoading = false;
        draft.hardDeleteSuccessful = false;
        break;
    }
  });

export default audienceDetailReducer;
